export const MIN_PRICE_PROMO_LABEL = 'min_price';
export const RRP_PRICE_PROMO_LABEL = 'rrp_price';
